import { observable, computed } from 'mobx'
import { getMenu, getSettingMenu, replacePaths } from '../NewMenu/constant'
import { getKeyPathItem } from './util'
import mainStore from '@components/Main/store'
import Api from '@api/authentication'
import { TOP_BANNER_HEIGHT, TOP_HEADER_HEIGHT } from '@constant'

class Store {
  @observable authMenuIds = []
  @observable menuData = { selectedKeyPath: [] }
  @observable isSettingSelected = false // 设置菜单是否选中

  constructor(pathname) {
    this.MENU = [] // getMenu().filter(Boolean)
    this.SETTING_MENU = getSettingMenu()
    this.setMenuData(pathname)
  }

  // menu 据页面顶部的 offset
  @computed
  get menuOffset() {
    return mainStore.posterStore.hasBannerPoster
      ? TOP_BANNER_HEIGHT + TOP_HEADER_HEIGHT
      : TOP_HEADER_HEIGHT
  }

  initMenu = async () => {
    const menu = await getMenu()
    this.MENU = menu.filter(Boolean)
  }

  handlePathname = pathname => {
    // 这一段用于替换路径，用于匹配菜单，比如 /localMerchant/liveManage 对应到营销菜单下
    Object.keys(replacePaths).forEach(key => {
      const regex = new RegExp(`${key}`)
      pathname = pathname.replace(regex, replacePaths[key])
    })
    return `/localMerchant/${pathname.split('/')[2]}`
  }

  getMenuIds = async () => {
    const { data } = await Api.menuIds()
    this.authMenuIds = data
  }

  isPathInSetting = pathname => {
    let subMenuPath = []
    this.SETTING_MENU.forEach(item => {
      subMenuPath = subMenuPath.concat(item.sub)
    })

    return subMenuPath.some(item => item && item.path === pathname)
  }

  setMenuData = pathname => {
    pathname = this.handlePathname(pathname)

    // 如果设置菜单中的路径匹配到了，则菜单选中
    if (this.isPathInSetting(pathname)) {
      this.isSettingSelected = true
      return
    }

    const selectedKeyPathItem = getKeyPathItem('path', pathname, this.MENU)

    // 只有1项则是 selectedKey
    switch (selectedKeyPathItem.length) {
      case 0:
        this.menuData = {
          openKey: '',
          selectedKey: '',
          selectedKeyPath: selectedKeyPathItem
        }
        break
      case 1:
        this.menuData = {
          openKey: '',
          selectedKey: selectedKeyPathItem[0],
          selectedKeyPath: selectedKeyPathItem
        }
        break
      case 2:
        const [openKey, selectedKey] = selectedKeyPathItem
        this.menuData = {
          openKey,
          selectedKey,
          selectedKeyPath: selectedKeyPathItem
        }
    }

    mainStore.setSubMenuOpen(selectedKeyPathItem.length === 2)
  }

  /**
   * type 用于区分设置中的菜单
   * 传 setting 表示点击了设置中的二级菜单
   */
  onMenuClick = (id, type, path) => {
    const isSettingSubMenuClicked = type === 'setting'

    this.handleSettingMenuSelect(isSettingSubMenuClicked)

    if (isSettingSubMenuClicked) {
      if (mainStore.subMenuOpen) {
        mainStore.setSubMenuOpen(false)
      }
      this.menuData = {
        openKey: '',
        selectedKey: '',
        selectedKeyPath: []
      }
      return
    }

    const keyPath = getKeyPathItem('id', id, this.MENU)
    if (keyPath.length === 1) {
      this.menuData.openKey = ''
    }
    mainStore.setSubMenuOpen(keyPath.length === 2)

    // 判断是否取消了跳转，取消了之后就不改变菜单
    if (window.location.hash.replace('#', '') != path) {
      return
    }
    this.menuData = {
      ...this.menuData,
      selectedKey: id,
      selectedKeyPath: keyPath
    }
  }

  onMenuOpenChange = id => {
    this.menuData = { ...this.menuData, openKey: id }
  }

  isSelecedKeyChildOfCurrentOpenKey = () => {
    const { openKey, selectedKey } = this.menuData
    const selectedKeyPath = getKeyPathItem('id', selectedKey, this.MENU)
    return {
      isChild: selectedKeyPath[0] === openKey,
      selectedKeyPath
    }
  }

  /**
   * 第一级的菜单id
   */
  isFirstLevelId = id => {
    return this.MENU.some(item => item.id === id)
  }

  /**
   * 当 Menu.Item（包括设置中的二级菜单）被点击时
   * 处理“设置”菜单选中状态
   */
  handleSettingMenuSelect = isSettingSubMenuClicked => {
    if (isSettingSubMenuClicked) {
      if (!this.isSettingSelected) {
        this.isSettingSelected = true
      }
    } else {
      if (this.isSettingSelected) {
        this.isSettingSelected = false
      }
    }
  }
}

export default Store
